import { type ReactElement, type ReactNode } from 'react';

type TileProps = {
  href: string;
  variant: 'primary' | 'secondary';
  icon: ReactElement;
  children: ReactNode;
};

const Tile = ({ href, variant, icon, children }: TileProps) => (
  <a href={href} className={`tile tile--${variant}`}>
    <span className="tile__icon">{icon}</span>
    <span className="tile__label">{children}</span>
  </a>
);

export default Tile;
